<template>
  <div class="scale" v-show="isShow" id="scale">
    <div class="scaleBg" @click="hide"></div>
    <div class="scaleContent" id="scaleImg">
      <img-v3 :src="imgUrl" alt />
    </div>
  </div>
</template>
<script>
import Hammer from "hammerjs";
const translateStep = 2;
const scaleStep = 0.05;
const maxTranslate = 100;
const minTranslate = -100;
let eleScale = null;
let eleScaleImg = null;
let scaleStr = "";
let translateStr = "";
export default {
  name: "Scale",
  props: {
    imgUrl: {
      type: String,
      default: ""
    }
  },
  mounted() {
    setTimeout(() => {
      eleScale = document.getElementById("scale");
      eleScaleImg = document.getElementById("scaleImg");
      this.initHammer(eleScale);
    }, 100);
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    initHammer(ele) {
      const mc = new Hammer.Manager(ele);
      const pinch = new Hammer.Pinch();
      const rotate = new Hammer.Rotate();
      var pan = new Hammer.Pan();
      let scale = 1;
      let _left = 0;
      let _top = -50;
      pinch.recognizeWith(rotate);
      mc.add([pinch, rotate, pan]);
      mc.get("pan").set({ direction: Hammer.DIRECTION_ALL });
      mc.on("pinchout", function(ev) {
        scale += scaleStep;
        if (scale >= 4) {
          scale = 4;
        }
      });
      mc.on("pinchin", function(ev) {
        scale -= scaleStep;
        if (scale <= 1) {
          scale = 1;
        }
      });
      mc.on("pinchend", function(ev) {
        const per = scale * 100;
        scaleStr = `scale(${scale},${scale})`;
        eleScaleImg.style.webkitTransform = `${scaleStr} ${translateStr}`;
        console.log("scale", scale);
      });
      mc.on("panleft panright panup pandown", function(ev) {
        const type = ev.type;
        switch (type) {
          case "panleft":
            _left = _left - translateStep;
            if (_left <= minTranslate) {
              _left = minTranslate;
            }
            break;
          case "panright":
            _left = _left + translateStep;
            if (_left >= maxTranslate) {
              _left = maxTranslate;
            }
            break;
          case "panup":
            _top = _top - translateStep;
            if (_top <= minTranslate) {
              _top = minTranslate;
            }
            break;
          case "pandown":
            if (_top >= maxTranslate) {
              _top = maxTranslate;
            }
            _top = _top + translateStep;
            break;
        }
        console.log("left", _left, "top", _top);
        translateStr = `translate(${_left}%,${_top}%)`;
        eleScaleImg.style.webkitTransform = `${scaleStr} ${translateStr}`;
      });
    },
    show() {
      this.isShow = true;
      scaleStr = `scale(1)`;
      translateStr = `translate(0,-50%)`;
      if (eleScaleImg) {
        eleScaleImg.style.webkitTransform = `${scaleStr} ${translateStr}`;
      }
    },
    hide() {
      this.isShow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.scale {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .scaleBg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.9;
  }
  .scaleContent {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    text-align: center;
    transform: translate(0, -50%);
    img {
      width: 100%;
      transition: all 0.5s;
    }
  }
}
</style>


